import React from 'react';
import PropTypes from 'prop-types';
import { gql, useQuery } from '@apollo/client';
import ReactHtmlParser from 'react-html-parser'; 
import './About.css';
import ReactPlayer from 'react-player'
import './PackGroupContents.css';
import { Navigate } from 'react-router-dom';
import Markdown from 'react-markdown';

const PACKGROUP_CONTENTS_QUERY = gql`query PackGroupContentsQuery($group_name: String!) {
    packGroups(filters:{ is_active:{eq:true}, name: {eq:$group_name} }){
      id: documentId,
      description,
      name,
      title,
      synth,
      demo_video,
      demo_audio,
      packs{
        id: documentId,
        demo_video,
        demo_audio,
        tagline,
        description,
        cover{
          url
        },
        patch_count,
        original_price,
        price,
        volume,
        is_active,
        buy_button,
        buy_button_sandbox
      },
      cover{
        url
      }
    }
  }
`;

const PackGroupContents = ({onLightboxShowcase, pack_group}) => {
  const { loading, error, data } = useQuery(PACKGROUP_CONTENTS_QUERY, {
    variables: {"group_name":pack_group},
  });

  const getOriginalPrice = (price) => {
      return parseFloat(((parseFloat(price)/2)*3).toPrecision(3)).toFixed(2);
  }

  const showcaseCover = (packgroup, pack) => {
      onLightboxShowcase(process.env.REACT_APP_API_ENDPOINT+pack?.url, `${packgroup.title} - ${packgroup.synth}: Volume ${pack.volume} Cover`)
  }

  const isProduction = process.env.NODE_ENV === 'production'

  if(loading) return <h4>...loading</h4>;
  if(error) return <h4>{error.message}</h4>;

  if(!data.packGroups[0]){
    return <Navigate to="/" />;
   }

    return (
      <div id="about" className="small-12 large-12 columns">
        <div className="panel">
       <h4 className="modal-title">{data.packGroups[0].title} for the {data.packGroups[0].synth}</h4>
       <div className="patch-group-description" dangerouslySetInnerHTML={{ __html: data.packGroups[0].description }} />
        {
           data.packGroups[0].demo_video ? (<div style={{marginTop:"1.5rem"}}>
             <small>Preview:</small>
             <ReactPlayer url={data.packGroups[0].demo_video} width={"100%"} style={{display:"inline-block"}} volume={1} config={{youtube:{playerVars:{modestbranding:1}}}} controls={true}/>
             </div>
           )
           : null
         }

         { data.packGroups[0].demo_audio ?
           <div style={{marginTop:"1.5rem"}}>
           <small>Audio only Preview:</small>
           <div>{ReactHtmlParser (data.packGroups[0].demo_audio)}</div>
           </div>
           : null
         }

       { 
         data.packGroups[0].packs.map(pack => (
           <div key={pack.id}>

           <h5 style={{marginTop:"2rem"}}>• Volume {pack.volume}</h5>
            {
               pack.demo_video ? (<div style={{marginBottom:"1rem"}}>
                 <small>Preview:</small>
                 <div className="small-12 video-container">
                   <ReactPlayer url={pack.demo_video} width="100%" style={{display:"inline-block"}} volume={1} config={{youtube:{playerVars:{modestbranding:1}}}} controls={true}/>
                 </div>
                 </div>
               )
               : null
             }
             { pack.demo_audio ?
               <div style={{marginBottom:"1rem"}}>
               <small>Audio only Preview:</small>
               <div>{ReactHtmlParser (pack.demo_audio)}</div>
               </div>
               : null
             }
             <div className="small-12 large-2 columns" style={{alignSelf:"center"}}>
               <img alt="pack cover" className="patch-cover" src={process.env.REACT_APP_API_ENDPOINT+pack.cover?.url} onClick={() => showcaseCover(data.packGroups[0],pack)} />
             </div>
             <div className="small-12 large-10 columns patch-info-container">
                 <span className="patch-price">${pack.price}</span><span className="patch-offer">Launch offer <small className="patch-offer-details">(Regular price ${pack.original_price || getOriginalPrice(pack.price)})</small></span><br />
                 <span className="patch-header">{data.packGroups[0].title}</span> for the {data.packGroups[0].synth} • <span className="patch-volume">{`Volume ${pack.volume}`}</span> • <span className="patch-patch_count">{pack.patch_count} patches</span>
                 <br/>
                 <span className="patch-download-type">INSTANT DIGITAL DOWNLOAD</span>
               
                 <div style={{marginTop:"0.5rem"}}>
                   { ReactHtmlParser (isProduction ? pack.buy_button : pack.buy_button_sandbox) }
                 </div>
             </div>
             <div style={{clear:"both"}}></div>
           </div>
         ))
       }
        </div>
      </div>
    )
  }

PackGroupContents.propTypes = {
  onLightboxShowcase: PropTypes.func.isRequired,
  pack_group: PropTypes.string.isRequired,
};

export default PackGroupContents
